import SpringIcon from '../common/svg-icons/SpringIcon';
import ReactIcon from '../common/svg-icons/ReactIcon';
import JavaIcon from '../common/svg-icons/JavaIcon';
import PostgreSqlIcon from '../common/svg-icons/PostgreSqlIcon';
import NodeIcon from '../common/svg-icons/NodeIcon';
import PythonIcon from '../common/svg-icons/PythonIcon';
import AngularIcon from '../common/svg-icons/AngularIcon';
import ReduxIcon from '../common/svg-icons/ReduxIcon';
import TypescriptIcon from '../common/svg-icons/TypescriptIcon';
import JavascriptIcon from '../common/svg-icons/JavascriptIcon';
import HtmlIcon from '../common/svg-icons/HtmlIcon';
import CssIcon from '../common/svg-icons/CssIcon';

export default [
  {
    name: 'React',
    icon: ReactIcon
  },
  {
    name: 'Redux',
    icon: ReduxIcon
  },
  {
    name: 'Spring',
    icon: SpringIcon
  },
  {
    name: 'Java',
    icon: JavaIcon
  },
  {
    name: 'Typescript',
    icon: TypescriptIcon
  },
  {
    name: 'Javascript',
    icon: JavascriptIcon
  },
  {
    name: 'PostgreSQL',
    icon: PostgreSqlIcon
  },
  {
    name: 'Node JS',
    icon: NodeIcon
  },
  {
    name: 'Python',
    icon: PythonIcon
  },
  {
    name: 'Angular',
    icon: AngularIcon
  },
  {
    name: 'HTML5',
    icon: HtmlIcon
  },
  {
    name: 'CSS3',
    icon: CssIcon
  }
];
